<template>
  <div class="area-chart-container">
    <VueApexCharts type="pie" height="400" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable arrow-parens */

import VueApexCharts from 'vue-apexcharts';
import numberUtils from '@/utils/numberUtils';

export default {
  mixins: [numberUtils],
  props: {
    series: {
      type: Array,
    },
    colors: {
      type: Array,
    },
    labels: {
      type: Array,
    },
    dataType: {
      type: String,
      default: 'percent',
    },
    showLegend: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    VueApexCharts,
  },
  watch: {
    labels(newLabel) {
      Object.assign(this.chartOptions.labels, newLabel);
    },
  },
  methods: {
    cutString(string) {
      if (string.length > 15) {
        return `${string.substring(0, 15)} ...`;
      }
      return string;
    },
    cutShortString(string, stringLength) {
      if (string.length > Number(stringLength)) {
        return `${string.substring(0, Number(stringLength))} ...`;
      }
      return string;
    },
  },
  data() {
    return {
      chartOptions: {
        plotOptions: {
          pie: {
            customScale: 1,
            expandOnClick: true,
            offsetX: this.showLegend ? -150 : 0,
            offsetY: 0,
            donut: {
              labels: {
                show: false,
                total: {
                  showAlways: false,
                  show: false,
                },
              },
            },
            dataLabels: {
              enabled: false,
              offset: 0,
              minAngleToShowLabel: 10,
              textAnchor: 'middle',
              dropShadow: {
                enabled: false,
              },
            },
          },
        },
        stroke: {
          show: false,
          width: 0,
          curve: 'stepline',
          lineCap: 'round',
          dashArray: 0,
        },
        fill: {
          colors: this.colors,
        },
        colors: this.colors,
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          theme: 'light',
          y: {
            formatter: (value) => {
              if (this.dataType !== 'percent') {
                return `${this.transformUnit(value)}`;
              }
              return `${value ? value.toFixed(2) : 0} %`;
            },
          },
        },
        legend: {
          show: this.showLegend,
          offsetY: 70,
          position: 'right',
          horizontalAlign: 'center',
          floating: true,
          labels: {
            useSeriesColors: false,
          },
          formatter: (seriesName, opts) => {
            if (this.dataType !== 'percent') {
              return `${seriesName} ${this.transformUnit(
                opts.w.globals.series[opts.seriesIndex],
              )}`;
            }
            return `<span class="">${seriesName} <span class="ml-2 mt-1 float-right">${opts.w.globals.series[
              opts.seriesIndex
            ].toFixed(2)} %</span></span>
            `;
          },
          markers: {
            width: 20,
            height: 12,
            strokeWidth: 0,
            strokeColor: '#fff',
            fillColors: this.colors,
            radius: 25,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0,
          },
        },
        labels: this.labels,
        responsive: [
          {
            breakpoint: 1700,
            options: {
              plotOptions: {
                pie: {
                  offsetX: 0,
                  offsetY: 0,
                  // customScale: 1,
                  // offsetX: -10,
                },
              },
              legend: {
                show: this.showLegend,
                position: 'right',
                horizontalAlign: 'center',
                offsetY: 50,
                fontSize: '10px',
                floating: false,
                formatter: (seriesName, opts) => {
                  if (this.dataType !== 'percent') {
                    return `${seriesName} ${this.transformUnit(
                      opts.w.globals.series[opts.seriesIndex],
                    )}`;
                  }
                  return `<span>${this.cutString(
                    seriesName,
                    10,
                  )}  <span class="ml-2 mt-1 float-right">${opts.w.globals.series[
                    opts.seriesIndex
                  ].toFixed(1)} %</span></span>`;
                },
              },
            },
          },
          {
            breakpoint: 1500,
            options: {
              plotOptions: {
                pie: {
                  customScale: 0.9,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
              legend: {
                show: this.showLegend,
                position: 'right',
                horizontalAlign: 'center',
                offsetY: 10,
                fontSize: '10px',
                floating: true,
                formatter: (seriesName, opts) => {
                  if (this.dataType !== 'percent') {
                    return `${seriesName} ${this.transformUnit(
                      opts.w.globals.series[opts.seriesIndex],
                    )}`;
                  }
                  return `<span>${this.cutString(
                    seriesName,
                    10,
                  )}  <span class="ml-2 mt-1 float-right">${opts.w.globals.series[
                    opts.seriesIndex
                  ].toFixed(1)} %</span></span>`;
                },
              },
              markers: {
                width: 12,
                height: 12,
              },
            },
          },
          {
            breakpoint: 1300,
            options: {
              plotOptions: {
                pie: {
                  customScale: 0.68,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
              legend: {
                show: this.showLegend,
                position: 'right',
                horizontalAlign: 'center',
                offsetY: 30,
                fontSize: '10px',
                floating: true,
                formatter: (seriesName, opts) => {
                  if (this.dataType !== 'percent') {
                    return `${seriesName} ${this.transformUnit(
                      opts.w.globals.series[opts.seriesIndex],
                    )}`;
                  }
                  return `<span>${this.cutString(
                    seriesName,
                    8,
                  )}  <span class="ml-2 mt-1 float-right">${opts.w.globals.series[
                    opts.seriesIndex
                  ].toFixed(1)} %</span></span>`;
                },
                markers: {
                  width: 8,
                  height: 8,
                },
              },
            },
          },
          {
            breakpoint: 1100,
            options: {
              plotOptions: {
                pie: {
                  // customScale: 0.5,
                  // offsetX: -70,
                  // offsetY: -40,
                },
              },
              legend: {
                show: this.showLegend,
                position: 'right',
                horizontalAlign: 'center',
                offsetY: 20,
                fontSize: '10px',
                floating: true,
                formatter: (seriesName, opts) => {
                  if (this.dataType !== 'percent') {
                    return `${seriesName} ${this.transformUnit(
                      opts.w.globals.series[opts.seriesIndex],
                    )}`;
                  }
                  return `<span>${this.cutShortString(
                    seriesName,
                    8,
                  )}  <span class="ml-2 mt-1 float-right">${opts.w.globals.series[
                    opts.seriesIndex
                  ].toFixed(1)} %</span></span>`;
                },
                markers: {
                  width: 8,
                  height: 8,
                },
              },
            },
          },
          {
            breakpoint: 769,
            options: {
              plotOptions: {
                pie: {
                  customScale: 1,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
              legend: {
                show: this.showLegend,
                position: 'right',
                horizontalAlign: 'center',
                offsetY: 20,
                fontSize: '10px',
                floating: false,
                formatter: (seriesName, opts) => {
                  if (this.dataType !== 'percent') {
                    return `${seriesName} ${this.transformUnit(
                      opts.w.globals.series[opts.seriesIndex],
                    )}`;
                  }
                  return `<span>${this.cutShortString(
                    seriesName,
                    8,
                  )}  <span class="ml-4 mt-1 float-right">${opts.w.globals.series[
                    opts.seriesIndex
                  ].toFixed(1)} %</span></span>`;
                },
                markers: {
                  width: 8,
                  height: 8,
                },
              },
            },
          },
          {
            breakpoint: 576,
            options: {
              plotOptions: {
                pie: {
                  customScale: 0.75,
                  offsetX: 0,
                  offsetY: 0,
                  dataLabels: {
                    enabled: false,
                    minAngleToShowLabel: 15,
                  },
                },
              },
              legend: {
                show: this.showLegend,
                position: 'bottom',
                horizontalAlign: 'center',
                offsetY: -5,
                fontSize: '10px',
                floating: false,
                formatter: (seriesName, opts) => {
                  if (this.dataType !== 'percent') {
                    return `${seriesName} ${this.transformUnit(
                      opts.w.globals.series[opts.seriesIndex],
                    )}`;
                  }
                  return `<span>${this.cutShortString(
                    seriesName,
                    10,
                  )}  <span class="">${opts.w.globals.series[
                    opts.seriesIndex
                  ].toFixed(1)} %</span></span>`;
                },
                markers: {
                  width: 10,
                  height: 10,
                },
              },
            },
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
